import { EpimsBaseEntityDto } from './epim-base.dto';
export class ContactTypeDto extends EpimsBaseEntityDto {

    ContactTypeId: string;

    ContactTypeName: string;

   
    

}